export const KAHVE_MEDIHA = [
  {
    id: "km001",
    metin: "{{ad}}, bu fincanı görünce içim sıkıştı biraz. Ama merak etme, kötü değil bu. Fincanının dibinde biriken o kahve, geçmişte yaşadığın bir yorgunluğun izi. {{soru}} diye soruyorsun ya, işte tam da o konuda sana şunu söyleyeyim: aceleci davranma. Sabırla beklersen, istediğin kapı kendiliğinden açılacak.\n\nYakında seni seven biri sürpriz bir haberle gelecek. O habere hazır ol — iyi şeyler bazen en az beklediğimiz anda kapıyı çalar.",
    tema: "sabir"
  },
  {
    id: "km002",
    metin: "{{ad}}, otur bir dakika, bu fincan çok şey anlatıyor bana. Şu an zor bir dönemdesin, hissediyorum. Ama bak, fincanının kenarına tırmanmış o kahve lekesi — bu çıkış işareti. {{soru}} meselesi seni yordu, biliyorum.\n\nAma yakında nefes alacaksın. Birileri senin için uğraşıyor, bilmiyorsun bile. Yalnız olmadığını hissetmek için bazen sadece etrafına bakman yeterli.",
    tema: "umut"
  },
  {
    id: "km003",
    metin: "{{ad}}, ne fincan bu! Ortasındaki o şekle bak, tam bir yol ayrımı. {{soru}} konusunda kafan karışık değil mi? İki seçenek önünde duruyor, ikisi de yanlış değil ama birisi seni daha mutlu edecek.\n\nKalbinin sesini dinle, aklın değil. Önümüzdeki hafta içinde bir işaret gelecek, dikkat et. Hayat bize cevapları her zaman kelimelerle vermez — bazen bir his, bazen bir tesadüf.",
    tema: "karar"
  },
  {
    id: "km004",
    metin: "{{ad}}, bu fincanı çevirirken elim titredi az. Neden mi? Çünkü burada para ve bereket işareti var! {{soru}} diye soruyorsun ama asıl sürpriz başka bir yerden gelecek.\n\nMaddi konularda önümüzdeki ay iyi gelişmeler var. Ama sakın savurgan olma, biriktir. Bereket geldiğinde onu akıllıca kullanmak, bereketi daha uzun süre yanında tutar.",
    tema: "para"
  },
  {
    id: "km005",
    metin: "{{ad}}, dur bir dakika, şu fincanın sağ tarafına bak bakalım. Orada bir insan silüeti var, net görüyorum. Bu senin hayatına yeni girecek biri. {{soru}} ile hiç alakasız gibi görünüyor ama değil.\n\nBu kişi tam da o konuda sana yardımcı olacak. Açık ol, kapalı kapı arkasında kalma. Yeni insanlara şans ver — bazen en beklenmedik kişiler en büyük kapıları açar.",
    tema: "iliski"
  },
  {
    id: "km006",
    metin: "{{ad}}, fincanını elimde tutarken bir sıcaklık hissettim. Bu iyi enerji demek. {{soru}} konusunda endişelenme, çünkü fincanın bana şunu söylüyor: sen zaten doğru yoldasın, sadece güvenmiyorsun kendine.\n\nYakında gelecek bir haber seni rahatlatacak. O zamana kadar şikayeti bırak, şükret. Şükür enerjisi, endişe enerjisinin tam tersidir — ve çok daha güçlüdür.",
    tema: "guven"
  },
  {
    id: "km007",
    metin: "{{ad}}, bu fincan seni çok sevmiş! Bakıyorum da her yer temiz, berrak. Bu zihninin de berraklaşacağı anlamına geliyor. {{soru}} derdin artık o kadar büyük görünmeyecek yakında.\n\nBirisi seni düşünüyor, uzaktan seni izliyor. Belki eski bir arkadaş, belki de sandığından farklı biri. O düşünceye açık ol.",
    tema: "berraklık"
  },
  {
    id: "km008",
    metin: "{{ad}}, şu fincanın dibindeki dağınıklığa bakma sen, önemli olan kenarlar. Ve kenarlar çok konuşuyor! {{soru}} meselesi için şunu diyeyim: önce kendine bak.\n\nBaşkaları için harcadığın enerjinin yarısını kendine ver. Önümüzdeki dönem senin dönemin — fırsatı kaçırma. Kendine yatırım yapmak, en karlı yatırımdır.",
    tema: "kendilik"
  },
  {
    id: "km009",
    metin: "{{ad}}, bu fincan bana bir yolculuk gösteriyor. Fiziksel mi, manevi mi bilemiyorum ama bir hareket var. {{soru}} konusunda bulunduğun yerden farklı bir perspektif gerekiyor.\n\nBelki küçük bir tatil, belki yeni bir ortam. Değişim korkutucu ama sana iyi gelecek. Aynı yerden bakınca aynı şeyleri görürsün — yeri değiştir, manzara değişir.",
    tema: "degisim"
  },
  {
    id: "km010",
    metin: "{{ad}}, fincanında çok güzel bir şey var — ortada bir kalp şekli. {{soru}} ister aşk olsun ister başka bir şey, kalp enerjisi her kapıyı açar.\n\nYakında duygusal olarak güçleneceksin. Seni seven biri var, belki söyleyememiş henüz. O sevgiyi görmek için bazen sadece gözlerini açman yeterli.",
    tema: "ask"
  },
  {
    id: "km011",
    metin: "{{ad}}, bu fincan bana iş ve kariyer hakkında konuşuyor. {{soru}} ile ilgili kafana takılan o düğüm çözülecek yakında. Beklenmedik bir teklif veya fırsat geliyor.\n\nHemen karar verme, düşün — ama çok da uzatma, fırsat beklemez. İyi fırsatlar kapıyı bir kez çalar — onu duymak için hazır olmak lazım.",
    tema: "kariyer"
  },
  {
    id: "km012",
    metin: "{{ad}}, fincanını çevirince ilk gözüme çarpan şey o köşedeki nokta. Tek nokta, ama anlamlı. Bu, hayatına girecek tek ama çok önemli bir şeyi temsil ediyor. {{soru}} konusunda da öyle — çok seçenek değil, tek doğru yol var.\n\nVe sen onu zaten biliyorsun içinde. Dur, sessizleş, dinle. Cevap gürültünün altında bekliyor.",
    tema: "odak"
  },
  {
    id: "km013",
    metin: "{{ad}}, bu fincan bir film gibi! Her şey var içinde. Ama en çok dikkat çeken o dağ şekli. Önünde bir engel var ama aşılmaz değil. {{soru}} için biraz daha güç toplamalısın.\n\nYorulmuşsun, hissediyorum. Bir dinlen, sonra tekrar hamle yap. Dinlenmiş savaşçı, yorgun savaşçıdan çok daha güçlüdür.",
    tema: "engel"
  },
  {
    id: "km014",
    metin: "{{ad}}, fincanının sol tarafı geçmişi, sağ tarafı geleceği gösterir bende. Geçmişte bıraktığın bir şey var, tam çözülmemiş. {{soru}} derdin de belki oradan geliyor.\n\nO eski düğümü çözmeden yeni kapılar tam açılmıyor. Cesaretini topla ve o konuşmayı yap, o adımı at. Geçmişteki düğüm şimdiyi sıkıştırıyor — çöz onu, nefes al.",
    tema: "gecmis"
  },
  {
    id: "km015",
    metin: "{{ad}}, bu fincan sağlık ve enerji hakkında konuşuyor. Yorgun görünüyorsun. {{soru}} ne olursa olsun, önce bedenine bak.\n\nUyku düzenin, beslenmeni ihmal etmişsin. Fincan bana diyor ki: kendine biraz şefkat göster. Gerisi gelecek zaten. Sağlam beden, her şeyin temelidir.",
    tema: "saglik"
  },
  {
    id: "km016",
    metin: "{{ad}}, bu fincanı ters çevir bir de öyle bak. Gördün mü? Bambaşka bir şekil çıkıyor. İşte {{soru}} konusu da öyle — bakış açını değiştirince her şey farklı görünecek.\n\nYakında seni şaşırtacak bir gelişme var. Hazır ol. Şaşırmak kötü değil — yeni bilginin kapısıdır.",
    tema: "bakis_acisi"
  },
  {
    id: "km017",
    metin: "{{ad}}, fincanında bereket işaretleri çok. Bolluk geliyor ama sabır lazım. {{soru}} konusunda acele etme.\n\nTohumları ektinse, sulamaya devam et — hasat zamanı gelecek. Çevrendeki birileri seni fark etmiş, değerini biliyor. Güven — görülmek için bağırmak gerekmez.",
    tema: "bereket"
  },
  {
    id: "km018",
    metin: "{{ad}}, fincanının dibinde bir mektup şekli var. Haberler geliyor demek! {{soru}} ile ilgili beklediğin cevap yakında gelecek.\n\nUzaktan gelen bir ses, bir mesaj, bir haber. Telefona dikkat et bu hafta, önemli bir iletişim olacak. O mesajı bekle — ama sadece bekleyerek değil, hazırlanarak bekle.",
    tema: "haber"
  },
  {
    id: "km019",
    metin: "{{ad}}, bu fincan bana arkadaşlık ve çevre hakkında konuşuyor. {{soru}} konusunda yalnız değilsin aslında, ama yalnız hissediyorsun.\n\nÇevrene bak, gerçekten seni seven biri orada duruyor, göremiyorsun. Kapanma, açıl biraz. Yeni bir dostluk da kapıda. Bazen en güzel dostluklar, kendiliğinden gelir — ama buna açık olmak lazım.",
    tema: "dostluk"
  },
  {
    id: "km020",
    metin: "{{ad}}, bu fincan bana bir müjde veriyor. Bekleyip durduğun bir şey, artık bekleme süresi bitiyor. {{soru}} konusunda da gelişme olacak — ama tam umut kesmişken gelecek, dikkat et.\n\nSabırsızlanma, son virajdasın. Son virajda en az enerjiyle en büyük mesafeyi alırsın — sadece devam et.",
    tema: "mujde"
  },
  {
    id: "km021",
    metin: "{{ad}}, fincanında bir ev şekli görüyorum. Yuva, aile, köklere dair bir mesaj var. {{soru}} ne olursa olsun, temelin sağlam olursa her şey oturur yerine.\n\nAile içinde bir gerginlik varsa, yumuşat. Bir barışma, bir birleşme yakın. Köklere dönmek zayıflık değil, güçlenmek için en doğal yol.",
    tema: "aile"
  },
  {
    id: "km022",
    metin: "{{ad}}, fincanın kenarındaki o çizgiyi gördün mü? Uzun ve kesintisiz. Bu azim ve kararlılık demek. {{soru}} konusunda vazgeçme eğilimindeydin belki ama fincan diyor ki: pes etme.\n\nSonuca yakınsın, sadece bir adım daha. En büyük pişmanlıklar, bırakmaya en yakın anda bırakılanlardan gelir.",
    tema: "azim"
  },
  {
    id: "km023",
    metin: "{{ad}}, bu fincan biraz karmaşık ama güzel. Hayatın da şu an öyle. {{soru}} konusunda net bir cevap beklerken, cevap farklı bir yerden gelecek.\n\nSürprizlere açık ol. Planladığın gibi gitmeyecek ama gideceği yer daha iyi olacak. Hayat bazen en güzel şeyleri planlarımızın dışında saklar.",
    tema: "surpriz"
  },
  {
    id: "km024",
    metin: "{{ad}}, fincanında bir kuş şekli var — özgürlük, uçuş, yeni ufuklar. {{soru}} konusunda kendini kısıtlama. Daha geniş düşün, daha cesur ol.\n\nÖnünde açılan bir kapı var, girmekten korkma. Bu fırsatı değerlendirirsen pişman olmayacaksın. Kuş kafeste güvende ama gökyüzünde özgür — sen hangisini seçiyorsun?",
    tema: "ozgurluk"
  },
  {
    id: "km025",
    metin: "{{ad}}, şunu söyleyeyim: bu fincan genel olarak iyi enerji taşıyor. {{soru}} konusunda merak etme. Zorlu bir dönem geçirdin ama artık bitiyor.\n\nÖnündeki üç ay çok önemli — dikkatli, ama umutlu ol. Sevdiklerin yanında, yalnız değilsin. Ve yalnız olmadığını hissetmek, en zor yolları bile yürünür kılar.",
    tema: "genel"
  }
];